var generic = generic || {};
var site = site || {};

(function ($) {
  $(document).on('product:quickshop:available', '.js-quickshop-container', function () {
    Drupal.behaviors.productReplenishmentSelectV2.attach($(this));
  });

  Drupal.behaviors.productReplenishmentSelectV2 = {
    attach: function (context) {
      // @todo - trigger update on sku change if needed
      // Add replenishment menu event if enable_replenishment=true in config.
      if (!Drupal.settings.product_display || !Drupal.settings.product_display.has_replenishment) {
        return null;
      }

      var $template = $('.js-product-replenishment-select-v2', context);
      var $product = $template.closest('.js-product');
      var $addBtn = $('.js-add-to-cart', $product);
      var $replenishmentOneTime = $('.js-replenishment-one-time', $template);
      var $replenishmentSelect = $('.js-replenishment-select', $template);
      var $replenishmentWrapper = $('.js-product-replenishment-select-wrapper', $template);
      var $replenishmentSelectLabel = $('.js-product-replenishment-select-label', $template);
      var activeBtnClass = 'button--active';
      var activeSelectClass = 'selectBox-menuActive';
      var replenishmentOneTimeText = $replenishmentOneTime.text();
      var $overlayTrigger = $('.js-product-auto-replenishment-open', $template);
      var $oneClick = $('.js-one-click-btn');

      function resetReplenishmentSelect() {
        if (!$replenishmentSelect.length) {
          return null;
        }
        $replenishmentWrapper.removeClass(activeSelectClass);
        $replenishmentSelect.val(0);
        $replenishmentSelect.each(function () {
          var $select = $(this);

          if ($select.data('selectBox-control')) {
            $select.selectBox('refresh');
          }
        });
        $replenishmentSelectLabel.text(replenishmentOneTimeText);
        $oneClick.trigger('one_click_overlay:oneclickValidation');
      }

      $replenishmentOneTime
        .once()
        .click(function () {
          $addBtn.attr('data-replenishment', 0);
          if (!$(this).hasClass(activeBtnClass)) {
            $(this).addClass(activeBtnClass);
          }
          resetReplenishmentSelect();
        })
        .on('keydown', function (e) {
          var key = site.getKeycode(e);

          if (key === 13) {
            // Enter
            e.preventDefault();
            $addBtn.attr('data-replenishment', 0);
            if (!$(this).hasClass(activeBtnClass)) {
              $(this).addClass(activeBtnClass);
            }
            resetReplenishmentSelect();
          }
        });

      // Launch product_auto_replenishment partial in overlay
      var launchOverlay = function () {
        var rendered = site.template.get({
          name: 'product_replenishment_info_v1'
        });

        generic.overlay.launch({
          content: rendered,
          height: 460,
          width: 960,
          onClosed: function () {
            $replenishmentOneTime.focus();
          }
        });
      };

      $overlayTrigger
        .once()
        .click(function () {
          launchOverlay();
        })
        .on('keydown', function (e) {
          var key = site.getKeycode(e);

          if (key === 13) {
            // Enter
            e.preventDefault();
            launchOverlay();
          }
        });

      // When the replenishment select changes, update the add-to-bag
      // button's data-replenishment value.
      $replenishmentSelect.on('change', function () {
        var btnVal = this.value !== '_' ? this.value : 0;

        $('.js-one-click-btn').trigger('one_click_overlay:oneclickValidation');
        var replenishmentSelectText = this.options[this.selectedIndex].text;

        $addBtn.attr('data-replenishment', btnVal);
        if (btnVal === 0) {
          $replenishmentOneTime.addClass(activeBtnClass);
          resetReplenishmentSelect();
        } else {
          $replenishmentOneTime.removeClass(activeBtnClass);
          $replenishmentWrapper.addClass(activeSelectClass);
          $replenishmentSelectLabel.text(replenishmentSelectText);
        }
      });

      // Set add-to-bag default replenishment value to 0.
      $addBtn.attr('data-replenishment', 0);
    }
  };
})(jQuery);
